import { useSelector } from 'react-redux';

import { RecentDealsVariant, isMvRedesignActive } from '@makemydeal/dr-activities-recent-deals';
import { ScreenWidth, useMediaUp } from '@makemydeal/dr-dash-components';

export const useRecentDealsVariant = (): RecentDealsVariant => {
    const isRedesignActive = useSelector(isMvRedesignActive);
    const isLargeScreen = useMediaUp(ScreenWidth.LARGE);

    return isRedesignActive && isLargeScreen ? RecentDealsVariant.DOCKED : RecentDealsVariant.OVERLAY;
};
